// extracted by mini-css-extract-plugin
export default {"WidgetListed":"WidgetListed--XH89A"};